var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMemo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    viewBox: "0 0 18 18",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 2.99994H2.5C2.10218 2.99994 1.72064 3.15797 1.43934 3.43928C1.15804 3.72058 1 4.10211 1 4.49994V14.9999C1 15.3978 1.15804 15.7793 1.43934 16.0606C1.72064 16.3419 2.10218 16.4999 2.5 16.4999H13C13.3978 16.4999 13.7794 16.3419 14.0607 16.0606C14.342 15.7793 14.5 15.3978 14.5 14.9999V9.74994"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 1.87493C13.6734 1.57656 14.078 1.40894 14.5 1.40894C14.922 1.40894 15.3266 1.57656 15.625 1.87493C15.9234 2.17329 16.091 2.57797 16.091 2.99993C16.091 3.42188 15.9234 3.82656 15.625 4.12493L8.5 11.2499L5.5 11.9999L6.25 8.99993L13.375 1.87493Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemo);
export default __webpack_public_path__ + "static/media/memo.1eacdc93f8340994a6fc39ae96b0cf5b.svg";
export { ForwardRef as ReactComponent };